import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Aaryan Travels - Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions of Aaryan Travels"
        />
      </Helmet>

      {/* Page Header */}

<div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Terms & Conditions
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* <div className="page-header bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-center">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Terms & Conditions
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row justify-content-center">
            {/* CENTERED COLUMN */}
            <div className="col-12 col-md-10 col-lg-8 mx-auto">
              <div className="terms-content">
                <p>
                  <b className="highlight">1. Booking Confirmation:</b> All
                  bookings are subject to availability and will be confirmed
                  upon successful payment and issuance of a booking reference
                  number.
                </p>

                <p>
                  <b className="highlight">2. Payment:</b> Full payment is
                  required at the time of booking. Payments can be made online
                  or at our authorized offices.
                </p>

                <p>
                  <b className="highlight">
                    3. Cancellation and Rescheduling:
                  </b>{" "}
                  Cancellations and rescheduling are subject to our cancellation
                  policy. Fees may apply depending on the timing.
                </p>

                <p>
                  <b className="highlight">4. Passenger Responsibility:</b>{" "}
                  Passengers must carry valid identification and tickets. We
                  reserve the right to refuse boarding without proper
                  documentation.
                </p>

                <p>
                  <b className="highlight">5. Baggage Policy:</b> Limited
                  baggage is allowed per ticket. Additional baggage may incur
                  extra charges.
                </p>

                <p>
                  <b className="highlight">6. Travel Insurance:</b> We
                  recommend purchasing travel insurance to cover unforeseen
                  events.
                </p>

                <p>
                  <b className="highlight">7. Safety Regulations:</b>{" "}
                  Passengers must adhere to all safety regulations and
                  instructions from our staff.
                </p>

                <p>
                  <b className="highlight">8. Changes to Itinerary:</b> We
                  reserve the right to alter itineraries due to operational or
                  unforeseen circumstances.
                </p>

                <p>
                  <b className="highlight">9. Refusal of Service:</b> We may
                  refuse service to passengers exhibiting disruptive behavior
                  or violating terms.
                </p>

                <p>
                  <b className="highlight">10. Jurisdiction:</b> These terms
                  are governed by the laws of India. Any disputes shall be
                  resolved under the jurisdiction of the relevant courts.
                </p>

                <h3>General Policy</h3>
                <p>
                  <b className="highlight">Booking Procedure:</b> Book services
                  through our website, mobile app, or customer support.
                </p>
                <p>
                  <b className="highlight">Customer Service:</b> Our support
                  team is available to assist with inquiries and special
                  requests.
                </p>

                <h3>Refund Policy</h3>
                <p>
                  <b className="highlight">Cancellation Fees:</b> Fees may
                  apply based on the timing of the cancellation.
                </p>
                <p>
                  <b className="highlight">Refund Process:</b> Refunds will be
                  processed to the original payment method within the standard
                  timeframe.
                </p>
                <p>
                  <b className="highlight">No-Show Policy:</b> No-shows may not
                  be eligible for refunds.
                </p>
              </div>

              {/* Contact Info */}
              <div className="contact-info">
                <h2>Contact Us</h2>
                <p>
                  For any queries regarding our terms, feel free to reach out:
                </p>
                <ul>
                  <li>
                    <b>Phone:</b>{" "}
                    <a href="tel:+919730707888">+91 9730707888</a>
                  </li>
                  <li>
                    <b>Email:</b>{" "}
                    <a href="mailto:pramod@aaryantravels.com">
                      pramod@aaryantravels.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsConditions;
